import { StyleObject } from "styletron-react";

export const wrapperStyles = (center: any) => {
    return {
        display: 'flex',
        width: '100%',
        boxSizing: 'border-box',
        padding: '20px',
        justifyContent: center ? 'center' : 'flex-start',
    } as StyleObject;
}
